import Cookies from 'universal-cookie';

import roleManagement from '../../../utils/roleManagement';

const cookies = new Cookies();

/**
 * PRJCBUGEN-63941: True when a support agent is impersonating a customer (login-as-user).
 * In that session `userSubRole` is set to `supportAgent` while `userRole` reflects the
 * impersonated account (e.g. admin / owner) — which would otherwise have full access to
 * the Partner Cloud REST API token page. Support users must not be able to view or copy
 * a customer's Partner Cloud REST API token while impersonating that customer, regardless
 * of the impersonated account's own role.
 *
 * Mirrors the same idiom used in notificationSettingsAccess.js for the same bug class.
 */
export function isSupportAgentTokenAccessRestricted() {
  let subRole;
  try {
    subRole = roleManagement.getUserSubRole();
  } catch {
    subRole = null;
  }

  if (subRole === 'supportAgent') {
    return true;
  }
  if (subRole) {
    // Resolved to some other definite sub-role — not a support impersonation session.
    return false;
  }

  // getUserSubRole() swallows its own errors internally and returns null both when there's
  // no cookie at all and when decryption/parsing fails. Fail closed in the ambiguous case:
  // if the raw userSubRole cookie is present but couldn't be resolved to a role, still treat
  // this as a restricted (impersonation) session rather than assuming it's safe to show the token.
  return !!cookies.get('userSubRole');
}

/**
 * Whether the Partner Cloud REST API token(s) may be viewed/generated/copied/deleted
 * in the current session.
 */
export function canViewCloudRestApiToken() {
  return !isSupportAgentTokenAccessRestricted();
}
